import SphLink from './Link.vue';

export { SphLink };
export default SphLink;
